<!--
  --
  --
  --
  -->
<template>
  <v-sheet>
    <c-book-subheader>利用人数</c-book-subheader>

    <v-sheet class="pa-2 mb-4" color="secondary" rounded>
      <c-description class="text-caption">
        <p>
          ご利用になる人数を入力下さい。
        </p>
      </c-description>
    </v-sheet>

    <v-text-field
      label="利用人数"
      type="number" outlined
      suffix="名"
      :value="value"
      @change="$emit('change', $event - 0)"
      :min="1"
      :max="carseat"
      :rules="[rule.required('利用人数'), rule.peoples(carseat)]"
    />
  </v-sheet>
</template>

<script>
import CBookSubheader from '@/pages/book/components/CBookSubheader'
import CDescription from '@/components/CDescription'

export default {
  name: 'CPeoplesSheet',
  components: {
    CBookSubheader,
    CDescription
  },

  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Number
    }
  },
  computed: {
    carseat () {
      const car = this.getters['book/car']
      return car ? car.attributes.seats : 1
    }
  }
}
</script>
